import axios from 'axios';
import QS from 'qs';
// if (process.env.NODE_ENV == 'development') {    
//     axios.defaults.baseURL = 'http://192.168.0.124:8102';} 
// else if (process.env.NODE_ENV == 'debug') {    
//     axios.defaults.baseURL = 'http://192.168.0.124:8102';
// } 
// else if (process.env.NODE_ENV == 'production') {    
//     axios.defaults.baseURL = 'http://192.168.0.124:8102';
// }
axios.defaults.timeout = 30000
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
//get请求封装
export function get(url, params){    
    return new Promise((resolve, reject) =>{        
        axios.get(url, {            
            params: params        
        }).then(res => {
            resolve(res.data);
        }).catch(err =>{
            reject(err.data)        
    })
        
});}
//post请求封装
export function post(url, params) {
    console.log(params)
    return new Promise((resolve, reject) => {
         axios.post(url, params)
        .then(res => {
            resolve(res.data);
        })

        
        .catch(err =>{
            reject(err.data)
        })
    });
}


// WEBPACK FOOTER //
// ./src/request/http.js